import { useMemo } from "react";
import { ShiftType } from "@/types/db/shifts";
import StackNavigator, { Stack } from "./StackNavigator";
import AssignedSupervisorsScreen from "./screens/AssignedSupervisorsScreen";
import AddSupervisorsScreen from "./screens/AddSupervisorsScreen";
import { SupervisorsProvider, SupervisorType } from "./SupervisorsContext";

export interface ShiftSupervisorsNewProps {
  shift: ShiftType | null;
  loading?: boolean;
}

export function ShiftSupervisorsNew({ shift, loading }: ShiftSupervisorsNewProps) {
  const supervisors = useMemo(() => {
    if (!shift?.shift_supervisors) return [];

    return shift.shift_supervisors.map(
      (s): SupervisorType => ({
        user_id: s.user_id,
        user: s.user,
        permissions: s.permissions,
        meta_data: s.meta_data,
      }),
    );
  }, [shift]);

  return (
    <SupervisorsProvider
      supervisors={supervisors}
      loading={loading}
      shiftId={shift?.id}
      shiftLocation={shift?.location}
      projectLocation={shift?.project?.location}
      shiftMarkets={shift?.meta_data?.markets}
      projectMarkets={(shift?.project as any)?.meta_data?.markets}
    >
      <StackNavigator initialRouteName="AssignedSupervisors">
        <Stack.Screen
          name="AssignedSupervisors"
          component={AssignedSupervisorsScreen}
          options={{ title: "Supervisors" }}
        />
        <Stack.Screen name="AddSupervisors" component={AddSupervisorsScreen} options={{ title: "Add Supervisors" }} />
      </StackNavigator>
    </SupervisorsProvider>
  );
}
